export default () => {
    return [
        {
            path: '/registroAccessi',
            name: 'registroAccessi',
            component: () => import('./views/registroAccessi.vue'),
        },
    ];
};
